import * as array from './array';
import * as badges from './badges';
import * as datetime from './datetime';
import * as device from './device';
import * as delay from './delay';
import * as DOM from './DOM';
import * as email from './email';
import * as event from './event';
import * as list from './list';
import * as notifications from './notifications';
import * as number from './number';
import * as object from './object';
import * as observer from './observer';
import * as reactions from './reactions';
import * as request from './request';
import resolve from './resolve';
import * as reviewstatus from './reviewstatus';
import * as string from './string';
import * as tags from './tags';
import * as task from './task';
import * as taskpanel from './taskpanel';
import TaskPatcher from './TaskPatcher';
import * as url from './url';
import * as user from './user';
import * as watchers from './watchers';

export default {
  array: array,
  badges: badges,
  datetime: datetime,
  device: device,
  delay: delay,
  DOM: DOM,
  email: email,
  event: event,
  list: list,
  notifications: notifications,
  number: number,
  object: object,
  observer: observer,
  reactions: reactions,
  request: request,
  resolve: resolve,
  reviewstatus: reviewstatus,
  string: string,
  tags: tags,
  task: task,
  taskpanel: taskpanel,
  TaskPatcher: TaskPatcher,
  url: url,
  user: user,
  watchers: watchers
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/index.js
// module id = 670
// module chunks = 0